import React, { useState, useEffect } from 'react';
import styles from './MobileFilters.module.scss';
import { CheckboxesGroup } from '../CheckboxesGroup';

const MobileFilters = (props) => {
  const { 
    areFilterVisible,
    setAreFilterVisible,
    filterOptions,
    setFilter,
    selectedFilters,
    activeMobileFilterScreen
  } = props

  const mobileFilters = [
    {
      value: 'attrs',
      label: 'Showing in'
    },
    {
      value: 'rating',
      label: 'Age'
    },
    {
      value: 'genre',
      label: 'Genres'
    },
    {
      value: 'other',
      label: 'Other'
    }
  ];

  const [activeScreen, setActiveScreen] = useState('all');
  const [areAllSelected, setAreAllSelected] = useState(false);

  const getFilterName = () => {
    const labelToValue = {
      [window.mapiTranslations['Showing in']]: 'attrs',
      [window.mapiTranslations['Age']]: 'rating',
      [window.mapiTranslations['Genres']]: 'genre',
      [window.mapiTranslations['Other']]: 'other',
      'Showing in': 'attrs',
      'Age': 'rating',
      'Genres': 'genre',
      'Other': 'other',
      attrs: 'attrs',
      rating: 'rating',
      genre: 'genre',
      other: 'other'
    };

    return labelToValue[activeScreen] || 'other';
  };

  // toggle "All" option
  useEffect(() => {
    let filterValue = [];
    const filterName = getFilterName();
    const options = filterOptions?.[filterName] || [];

    // activeScreen
    if (areAllSelected) {
      options.forEach(option => {
        filterValue.push(option.value)      
      });
    }

    setFilter(filterName, filterValue, 'replace');
  }, [areAllSelected]);

  // change active screen
  useEffect(() => {
    setAreAllSelected(false);
  }, [activeScreen]);

  // change active screen by parent
  useEffect(() => {
    if (activeMobileFilterScreen) {
      setActiveScreen(activeMobileFilterScreen);
    }
  }, [activeMobileFilterScreen]);

  const handleClearClick = (e) => {
    e.preventDefault();

    if (areAllSelected) {
      setAreAllSelected(false);
    } else { // a couple of filters are selected, "All" button is not clicked
      setFilter(getFilterName(), [], 'replace');
    }
  }

  const handleCloseClick = (e) => {
    e.preventDefault(); 
    setAreFilterVisible(false);
  }

  let activeScreenFilter = '';
  if (activeScreen !== 'all') {
    activeScreenFilter = getFilterName();
  }

  return (
    <div className={styles.mobileFilters + (areFilterVisible ? (' ' + styles.active) : '')}>
      <div className={styles.mobileFiltersHeader}>
        {activeScreen === 'all' && 
          <React.Fragment>
            <h3>Filter</h3>

            <button type="button" className={styles.btnClose + ' ' + styles.buttonFilter} onClick={handleCloseClick}>X</button>
          </React.Fragment>
        }
        
        {activeScreen !== 'all' && 
          <React.Fragment>
            <h3>
              <button
                type="button"
                onClick={(e) => { e.preventDefault(); setActiveScreen('all'); }}
                className={styles.btnBack + ' ' + styles.buttonFilter}
              >
                &lt;
              </button> 

              {activeScreen}
            </h3>
    
            {(selectedFilters && selectedFilters[activeScreenFilter].length === 0) && 
              <button
                type="button"
                className={'btn ' + styles.btnSelectAll + ' ' + styles.buttonFilter}
                onClick={(e) => { e.preventDefault(); setAreAllSelected(true); }}
              >
                All
              </button>
            }

            {(selectedFilters && selectedFilters[activeScreenFilter].length > 0) && 
              <button
                type="button"
                className={'btn ' + styles.btnSelectAll + ' ' + styles.buttonFilter}
                onClick={handleClearClick}
              >
                Clear
              </button>
            }
          </React.Fragment>
        }
      </div>

      <div className={styles.mobileFiltersContent}>
        {activeScreen === 'all' && 
          <ul className={styles.allFilterList}>
            {
              mobileFilters.map(filter => {
                return (
                  <li key={filter.value}>
                    <button type="button" className={styles.buttonFilter} onClick={(e) => { e.preventDefault(); setActiveScreen(filter.label); }}>
                      {filter.label}

                      {
                        ( 
                          selectedFilters[filter.value].length === 0
                          || filterOptions[filter.value].length === 0
                        ) && 
                        <span>All</span>
                      }
                      
                      {
                        ( selectedFilters[filter.value].length > 0 ) && 
                        <span>{selectedFilters[filter.value][0] + (selectedFilters[filter.value].length > 1 ? ',...' : '')}</span>
                      }
                    </button>
                  </li>
                );
              })
            }
          </ul>
        }

        {activeScreen === window.mapiTranslations['Showing in'] && 
          <CheckboxesGroup 
            fieldName="field-attrs[]"
            filterOptions={filterOptions.attrs}
            setFilter={setFilter}
            selectedFilters={selectedFilters}
          />
        }

        {activeScreen === window.mapiTranslations['Age'] && 
          <CheckboxesGroup 
            fieldName="field-rating[]"
            filterOptions={filterOptions.rating}
            setFilter={setFilter}
            selectedFilters={selectedFilters}
          />
        }

        {activeScreen === window.mapiTranslations['Genres'] && 
          <CheckboxesGroup 
            fieldName="field-genre[]"
            filterOptions={filterOptions.genre}
            setFilter={setFilter}
            selectedFilters={selectedFilters}
          />
        }

        {activeScreen === window.mapiTranslations['Other'] && 
          <CheckboxesGroup 
            fieldName="field-other[]"
            filterOptions={filterOptions.other}
            setFilter={setFilter}
            selectedFilters={selectedFilters}
          />
        }
      </div>
    </div>
  );
}

export { MobileFilters }
